import React from 'react';
import './ErrorPage.css';


export const ErrorPage = () => (
  <div className="error-page">
    <div className="error-page__content">
      <div className="error-page__message-wrapper">
        <div className="error-page__message">
          <div className="error-page__title">Oops!</div>
          <div className="error-page__text">Something went wrong.</div>
          <div className="error-page__text">Please click the back button in your browser and try again.</div>
        </div>
      </div>
    </div>
  </div>
);
